module.exports = __webpack_public_path__ + "img/newPayment.db6cb4ef.svg";